<template>
  <div id="forgetpass">
    <div class="login_box">
      <div class="login_cont">
        <div class="login_contRight right">
          <!--<div class="login_header">
            <p id="findPass">找回密码</p>
          </div>
          <div class="login_footer register">
            <p style="margin-top: 30px;">
              <span>手机号</span>
              <input
                type="tel"
                maxlength="11"
                style="width: 285px;padding-left: 10px;"
                placeholder="请输入手机号"
                v-model="phone"
              >
            </p>
            <p>
              <span>图形验证码</span>
              <input
                v-model="picCode"
                type="text"
                style="width: 194px;padding-left: 10px;"
                placeholder="请输入图形验证码"
              >
              <s-identify
                class="picCode"
                :identifyCode="identifyCode"
                :contentWidth="92"
                :contentHeight="42"
                @refreshcode="getRePicCode"
              ></s-identify>
            </p>
            <p>
              <span>短信验证码</span>
              <input
                v-model="phoneCode"
                type="text"
                placeholder="请输入短信验证码"
                style="width: 194px; padding-left: 10px;"
              >
              <button
                class="login_code"
                style="width: 87px;"
                v-bind:disabled="disabled"
                @click="getPhoneCode"
              >{{phoneCodeText}}</button>
            </p>
            <p>
              <span>输入新密码</span>
              <input
                type="password"
                placeholder="请输入新密码"
                style="width: 285px;padding-left: 10px;"
                v-model="pass"
              >
            </p>
            <p>
              <span style="width: 130px;">再次输入新密码</span>
              <input
                type="password"
                placeholder="再次输入新密码"
                style="width: 285px;padding-left: 10px;"
                v-model="confirm"
              >
            </p>
            <button class="register_btn" @click="forgetBtn">确定</button>
          </div>-->
          <el-card class="box-card" style="height: 100%">
            <div slot="header" class="clearfix">
              <span style="color: #E6A23C">忘记密码</span>
            </div>
            <div class="content">
              <el-form ref="form">
                <el-form-item>
                  <el-input maxlength="11" v-model.number="phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="rePicCode" placeholder="请输入图形验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <img :src="captcha" class="login_img" height="150" width="40" @click="this.getCaptcha">
                      <!-- <s-identify :identifyCode="identifyCode" class="login_img"
                                  :contentWidth="150"
                                  :contentHeight="40"
                                  @refreshcode="getRePicCode"></s-identify> -->
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="phoneCode" placeholder="请输入短信验证码">
                      </el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button type="info" @click="RealNameVerify" :disabled="disabled" style="width: 100%">{{phoneCodeText}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-input show-password v-model="pass" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input show-password v-model="confirm" placeholder="再次输入新密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" style="width: 100%" @click="forgetBtn">确定</el-button>
                </el-form-item>
              </el-form>
            </div>

          </el-card>
        </div>
      </div>
    </div>

    <el-dialog class="real_name_popup"  :visible.sync="getRealName" width="30%">
       <el-form ref="form" label-width="100px" size="small" style="margin-top:15px;">
         <el-form-item>
           <h4 slot="label">姓名:</h4>
           <el-input  v-model="realName" placeholder="请输入您的真实姓名"></el-input>
         </el-form-item>
         <el-form-item>
           <h4 slot="label">身份证号码：</h4>
           <el-input  v-model="card" placeholder="请输入您的卡"></el-input>
         </el-form-item>
       </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="getRealName = false">取消</el-button>
         <el-button type="primary" @click="getPhoneCode">确认</el-button>
       </div>
     </el-dialog>

  </div>
</template>
<script>
import SIdentify from "../components/icode";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import $ from "jquery";
export default {
  name: "Forgetpass",
  components: {
    SIdentify
  },
  data() {
    return {
      phone: "", //手机号
      picCode: "", //图形验证码
      phoneCode: "", //短信验证码
      identifyCode: "", //注册_图形验证码图片
      identifyCodes: "123456789",
      pass: "", //新密码
      confirm: "", //确认新密码
      phoneCodeText: "获取验证码",
      disabled: false,
      rePicCode: "", //注册_图形验证码
      captcha:'',
      verify_token:'',
       realName:"",
       card:"",
       getRealName:false
    };
  },
  mounted: function() {
    //获取图片验证码
    // this.getRePicCode();
    this.getCaptcha();
    // $("#wrapper").css("background", "#737373");
  },
  methods: {
    //获取注册 图片验证码
    // getRePicCode() {
    //   this.loginCode = "";
    //   this.identifyCode = "";
    //   this.makeCode(this.identifyCodes, 4);
    // },
    RealNameVerify(){
       let that = this;
       if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
         that.$message.error("手机号格式不正确");
       }
       else{
         that.$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "realname_verification",
             phone: that.phone
           },
         })
           .then(function(res) {
             let resData = res.data;
             if (resData.code == 1) {
               that.getRealName=true;
             } else if (resData.code == 0) {
               that.disabled = false;
               that.$message.error(res.data.msg);
             }
           });
       }
     },
     
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //创建图形验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    //获取短信验证码
    getPhoneCode() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$message.error("手机号格式不正确");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let forgetPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "forgot_code_e",
              phone: forgetPhone,
              rePicCode: that.rePicCode,
              verify_token:that.verify_token,
               realname:this.realName,
               card:this.card
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.getRealName=false;
              that.$message({
                message: res.data.msg,
                type: "success"
              });
              var time = 60;
              that.phoneCodeText = time + "s";
              that.disabled = true;
              var timer1 = setInterval(function() {
                time--;
                that.phoneCodeText = time + "s";
                if (time <= 0) {
                  that.phoneCodeText = "获取验证码";
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
            } else if (res.data.code == 0) {
              that.getRealName=false;
               that.realName='';
               that.card='';
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    forgetBtn() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$message.error("手机号格式不正确");
      } 
      // else if (that.picCode != that.identifyCode) {
      //   that.getRePicCode();
      //   that.$message.error("图片验证码不正确");
      // } 
      else if (that.phoneCode == "") {
        that.$message.error("请输入短信验证码");
      } else if (that.pass == "") {
        that.$message.error("请输入新密码");
      } else if (that.confirm == "") {
        that.$message.error("请再次输入新密码");
      } else if (that.confirm != that.pass) {
        that.$message.error("两次密码输入不一致");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let forgetPhone = that.encryptMessage(userPhone, publicKey);
        let forgetPassword = that.encryptMessage(that.pass, publicKey);
        let forgetPwConfirm = that.encryptMessage(that.confirm, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "forgot_password_e",
              phone: forgetPhone,
              code: that.phoneCode,
              password: forgetPassword,
              confirm: forgetPwConfirm
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success"
              });
              that.$router.push({
                path: "/login"
              });
              if (that.loginRememeber == true) {
                window.localStorage.setItem("name", that.loginName);
                window.localStorage.setItem("rememberName", true);
              } else {
                localStorage.removeItem("name");
                localStorage.removeItem("rememberName");
              }
            } else if (res.data.code == 0) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    getCaptcha(){
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "getSmsPic",
        },
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$message.error(res.data.msg);
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
  }
};
</script>
<style scoped>
@import url("./../assets/css/login.css");

.register > p {
  width: 437px;
  margin-left: 26px;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  margin-top: 25px;
  box-sizing: border-box;
}
.register > p > span {
  display: inline-block;
  box-sizing: border-box;
  padding-right: 10px;
  text-align: right;
  width: 130px;
  height: 40px;
}
input::-webkit-input-placeholder {
  color: white;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: white;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: white;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
}
.register_btn {
  background: #d11028;
  font-size: 16px;
  line-height: 40px;
  height: 40px;
  margin-left: 165px;
  margin-top: 43px;
  text-align: center;
  width: 287px;
  color: #fff;
  border-radius: 3px;
}
.login_agree {
  margin-left: 163px;
}
#findPass {
  text-align: left;
  background-color: #d9d9d9;
  font-size: 25px;
  padding-left: 45px;
}
.picCode {
  display: inline-block;
  width: 92px;
  height: 42px;
  position: absolute;
  right: 45px;
  top: 156px;
}
.content{
  width: 80%;
  margin: 0 auto;
  /*text-align: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/forgetpass.vue